import React, { useEffect, useState, useCallback } from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { LeftGrid } from './Episode.Styled';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  EPISODE_2284_REFERENCE_DATA_URL,
  EPISODE_AUTHORIZATION_REFERENCE_DATA_URL,
  EPISODE_CMP_REFERENCE_DATA_URL,
  paginationSize,
  PARTICIPANTS_EPISODE_DETAIL_URL,
} from '../../constants';
import Tooltip from '@mui/material/Tooltip';
import { DataGrid } from '@mui/x-data-grid';
import { Auth } from 'aws-amplify';
import { renderCellExpand } from '../common/GridCell/GridCellExpand';
import EpisodeDialog from './EpisodeDialog';
import { commonQueryParams } from '../../services/QueryParams/QueryParams';
import CommonSearch from '../common/Search/CommonSearch';
import { singleEpisode } from '../../redux/episode/episodeSlice';
import { getReferralReferenceData } from '../../redux/episode/referralTab/referralReferenceSlice';
import { setIsReferralDataLoaded } from '../../redux/episode/referralTab/referralFormSlice';
import { getProfA1ReferenceData } from '../../redux/episode/profA1Tab/profA1ReferenceSlice';
import { getProfA2ReferenceData } from '../../redux/episode/profA2Tab/profA2ReferenceSlice';
import { setIsProfA1DataLoaded } from '../../redux/episode/profA1Tab/profA1FormSlice';
import { getProfB1ReferenceData } from '../../redux/episode/profB1Tab/profB1ReferenceSlice';
import { setIsProfB1DataLoaded } from '../../redux/episode/profB1Tab/profB1FormSlice';
import { setIsProfA2DataLoaded } from '../../redux/episode/profA2Tab/profA2FormSlice';
import { getProfB2ReferenceData } from '../../redux/episode/profB2Tab/profB2ReferenceSlice';
import { setIsProfB2DataLoaded } from '../../redux/episode/profB2Tab/profB2FormSlice';
import { getActivitiesReferenceData } from '../../redux/episode/activitiesTab/activitiesReferenceSlice';
import { getAorcmReferenceData } from '../../redux/episode/aorvmTab/aorcmReferenceSlice';
import { getQualityAssuranceReferenceData } from '../../redux/episode/qualityAssuranceTab/qualityAssuranceReferenceSlice';
import { getStsAlertReferenceData } from '../../redux/episode/stsAlertTab/stsAlertReferenceSlice';
import {
  episodeParticipant,
  setRefreshEpisodeParticipant,
} from '../../redux/episode/episodeParticipant/episodeParticipantSlice';
import { participant } from '../../redux/participant/participantSlice';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { newEpisode } from '../../redux/participant/newEpisode/NewEpisodeSlice';
import { getAuthReferenceData } from '../../redux/episode/authTab/authReferenceSlice';
import { getEpisodeList } from './services/episodesApi';
import { get2284ReferenceData } from '../../redux/episode/2284Tab/2284Reference/2284ReferenceSlice';
import { getTransportReferenceData } from '../../redux/episode/transportTab/transportReference/transportReferenceSlice';
import { getCmpReferenceData } from '../../redux/episode/cmpTab/cmpReference/cmpReferenceSlice';
import TextField from '@mui/material/TextField';
import { getContactByUser } from '../Contact/services/contactsApi';
import { PARTICIPANT_EPISODE_DELETE_URL } from '../../constants';
import { deleteStopApi } from '../../services/StopApi/StopApi';

const Episode = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    singleParticipantId,
    episodeList,
    episodeListData,
    setEpisodeListData,
    searchEpisodeList,
    setSearchEpisodeList,
    onEpisodeCountChange,
  } = props;

  const [user, setUser] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [open, setOpen] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [episodeData, setEpisodeData] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 1,
    pageSize: 25,
    sortModel: '',
  });
  const episodeParticipantDetail = useSelector(
    (state) => state?.participants?.participantsDetail[0]
  );

  const episodeId = useSelector(
    (state) => state?.episodeDetail?.singleEpisode[0]?.episodeId
  );

  const [episodeComment, setEpisodeComment] = useState(null);

  useEffect(() => {
    const initUser = async () => {
      const userData = await getUser();
      setUser(userData);
    };

    if (!user) {
      initUser();
    } else if (user?.signInUserSession.accessToken.jwtToken && singleParticipantId) {
      fetchData();
    }
  }, [
    user,
    singleParticipantId,
    episodeData.pageSize,
    episodeData.page,
    episodeData.sortModel,
    searchText,
  ]);

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchReferenceData();
    }
  }, [user?.signInUserSession.accessToken.jwtToken]);

  const fetchReferenceData = async () => {
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    dispatch(getReferralReferenceData(authorization));
    dispatch(getProfA1ReferenceData(authorization));
    dispatch(getProfA2ReferenceData(authorization));
    dispatch(getProfB1ReferenceData(authorization));
    dispatch(getProfB2ReferenceData(authorization));
    dispatch(getActivitiesReferenceData(authorization));
    dispatch(getAorcmReferenceData(authorization));
    dispatch(getQualityAssuranceReferenceData(authorization));
    dispatch(getStsAlertReferenceData(authorization));
    dispatch(getTransportReferenceData(authorization));
  };

  const fetchData = async () => {
    setEpisodeData((old) => ({ ...old, isLoading: true }));
    let url = `${PARTICIPANTS_EPISODE_DETAIL_URL}${singleParticipantId}/episodes?`;
    const commonParams = commonQueryParams(url, searchText, episodeData);
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    dispatch(setIsReferralDataLoaded(false));
    dispatch(setIsProfA1DataLoaded(false));
    dispatch(setIsProfB1DataLoaded(false));
    dispatch(setIsProfA2DataLoaded(false));
    dispatch(setIsProfB2DataLoaded(false));
    dispatch(setRefreshEpisodeParticipant(false));
    const episodes = await getEpisodeList({
      commonParams,
      authorization,
    });
    setEpisodeData((old) => ({
      ...old,
      ...episodes,
    }));
    setEpisodeComment(episodes?.data[0]?.episodeComment);

    // Notify parent component of episode count
    if (onEpisodeCountChange) {
      onEpisodeCountChange(episodes?.total || 0);
    }
  };

  const getUser = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      try {
        const loggedInContact = await getContactByUser(user);
        user.contact = loggedInContact;
      } catch (error) {
        console.log('Error fetching contact');
      }
      return user;
    } catch (error) {
      console.log('Not signed in');
      return null;
    }
  };

  const handleSortModelChange = useCallback((sortModel) => {
    // Here you save the data you need from the sort model
    episodeList
      ? setEpisodeListData((old) => ({ ...old, sortModel: [...sortModel] }))
      : setEpisodeData((old) => ({ ...old, sortModel: [...sortModel] }));
  }, []);

  const QuickSearchToolbar = () => {
    return (
      <CommonSearch
        searchText={episodeList ? searchEpisodeList : searchText}
        setSearchText={episodeList ? setSearchEpisodeList : setSearchText}
      />
    );
  };

  const newEpisodeDialod = () => {
    const newEpisodePayload = {
      newEpisodeLoaded: true,
      episodeID: '',
      episodeSAPStartDate: '',
      expectedEPRD: '',
      actualAPRD: '',
      incarcerationInstitutionId: '',
      referralSourceId: '',
      cDCNumber: '',
      episodeComment: '',
      cCCMS: '',
      lastCountyofResidenceId: '',
      paroleCountyId: '',
      paroleAgentId: '',
      tIR: '',
      areaId: '',
      episodeDischargeDate: '',
      episodeDischargeReasonId: '',
      inactivity: '',
    };
    dispatch(newEpisode(newEpisodePayload));
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 700);
    setOpen(true);
  };

  //const handleClick = () => {
  //  navigate(`/episode/details/${episodeId}`);
  //};

  const updateEpisodeDialog = (episode) => {
    const updateEpisode = {
      episodeID: episode.row.episodeID,
      episodeSAPStartDate: episode.row.episodeSAPStartDate,
      expectedEPRD: episode.row.expectedEPRD,
      actualAPRD: episode.row.actualAPRD,
      incarcerationInstitutionId: episode.row.incarcerationInstitutionId?.id,
      referralSourceId: episode.row.referralSourceId?.id,
      cDCNumber: episode.row.cDCNumber,
      episodeComment: episode.row.episodeComment,
      cCCMS: episode.row.cCCMS,
      lastCountyofResidenceId: episode.row.lastCountyofResidenceId?.id,
      paroleCountyId: episode.row.paroleCountyId?.id,
      paroleAgentId: episode.row.paroleAgentId?.id,
      tIR: episode.row.tIR,
      areaId: episode.row.areaId?.id,
      episodeDischargeDate: episode.row.episodeDischargeDate,
      episodeDischargeReasonId: episode.row.episodeDischargeReasonId?.id,
      inactivity: episode.row.inactivity,
    };
    dispatch(newEpisode(updateEpisode));
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 700);
    setOpen(true);
  };

  const handleDeleteEpisode = async (params) => {
    if (!window.confirm('Are you sure you want to delete this episode?')) {
      return;
    }

    const url = `${PARTICIPANT_EPISODE_DELETE_URL}/${params.id}`;
    const payload = {};
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;

    deleteStopApi({ url, payload, authorization })
      .then((response) => {
        console.log('### delete response');
        console.log(response);
        fetchData();
      })
      .catch((error) => {
        const errorResponse = JSON.parse(error) 
        console.log('### delete error');
        console.log(errorResponse);
        // Check if error indicates related records exist
        if (errorResponse?.response?.status === 400 || errorResponse?.response?.status === 409 ||
            errorResponse?.message?.toLowerCase().includes('constraint') ||
            errorResponse?.response?.data?.toLowerCase().includes('constraint')) {
          alert('Cannot delete episode. All related episode records must be deleted before the episode can be deleted.');
        } else {
          alert('Failed to delete episode: ' + (errorResponse?.response?.data || errorResponse?.message || 'Unknown error'));
        }
      });
  };

  const episodeRowClick = (rowData) => {
    //console.log('### CLICK FROM EPISODE');
    //console.log(rowData)

    rowData.episodeId = rowData.id;
    const episode = [
      rowData,
      //{
      //episodeId: rowData.id,
      //referralSource: rowData.referralSource
      //},
    ];
    const paroleCounty = rowData.paroleCounty;
    const authReferenceUrl = `${EPISODE_AUTHORIZATION_REFERENCE_DATA_URL}/${
      rowData.id
    }/referencedata/${rowData.paroleCountyId?.id ?? rowData.paroleCountyId}`;
    const reference2284Url = `${EPISODE_2284_REFERENCE_DATA_URL}/${rowData.id}`;
    const cmpReferenceUrl = `${EPISODE_CMP_REFERENCE_DATA_URL}/${rowData.id}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    dispatch(getAuthReferenceData({ authReferenceUrl, authorization }));
    dispatch(get2284ReferenceData({ reference2284Url, authorization }));
    dispatch(getCmpReferenceData({ cmpReferenceUrl, authorization }));
    dispatch(singleEpisode(episode));

    if (episodeList) {
      //console.log(rowData);
      const participantDetail = [
        {
          key: rowData.participant.key,
          id: rowData.participant.id,
          lastName: rowData.participant.lastName,
          firstName: rowData.participant.firstName,
          middleName: rowData.participant.middleName,
          ssn: rowData.participant.SSN,
          suffix: rowData.participant.suffix,
          gender: rowData.participant.gender,
          ethnicityOrRace: rowData.participant.ethnicityOrRace,
          veteran: rowData.participant.veteran,
          deployedCombatDuty: rowData.participant.deployedCombatDuty,
          diagnosedPostTraumaticStressDisorder:
            rowData.participant.diagnosedPostTraumaticStressDisorder,
          arsonist: rowData.arsonist,
          dateOfBirth: rowData.participant.dateOfBirth,
          registration290: rowData.participant.registration290,
          inactive: rowData.participant.inactive,
          cdcNum: rowData.cDCNumber
        },
      ];
      dispatch(participant(participantDetail));
    }
    navigate(`/episode/details/${rowData.id}`);
  };

  const columnsData = [
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      //type: 'actions',
      hide: episodeList,
      renderCell: (params) => {
        return (
          <>
            <IconButton onClick={() => updateEpisodeDialog(params)}>
              <EditIcon />
            </IconButton>
            {user?.contact?.authLock === true && (
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteEpisode(params);
                }}
              >
                <DeleteIcon />
              </IconButton>
            )}
          </>
        );
      },
    },
    {
      field: 'episodeID',
      headerName: 'Episode Id',
      minWidth: 80,
      flex: 1,
      renderCell: (params) => {
        return (
          <Button
            variant="contained"
            size="small"
            onClick={() => episodeRowClick(params.row)}
          >
            {params.value}
          </Button>
        );
      },
    },
    {
      field: 'cDCNumber',
      headerName: 'CDC Number',
      minWidth: 70,
      renderCell: renderCellExpand,
      flex: 1,
    },
    {
      field: 'key',
      headerName: 'Participant Key',
      renderCell: renderCellExpand,
      flex: 1,
      minWidth: 140,
      hide: !episodeList,
    },
    {
      field: 'registration290',
      headerName: '290 Reg',
      type: 'boolean',
      minWidth: 70,
      flex: 1,
      hide: !episodeList,
    },
    {
      field: 'episodeSAPStartDate',
      headerName: 'SAP Start Date',
      editable: true,
      type: 'date',
      minWidth: 100,
      flex: 1,
    },
    {
      field: 'expectedEPRD',
      headerName: 'Expected Release',
      editable: true,
      type: 'date',
      minWidth: 100,
      flex: 1,
    },
    {
      field: 'prisonRelease',
      headerName: 'Prison Release',
      type: 'date',
      minWidth: 100,
      flex: 1,
      hide: !episodeList,
    },
    {
      field: 'reg',
      headerName: 'Reg',
      flex: 1,
      hide: !episodeList,
    },
    {
      field: 'actualAPRD',
      headerName: 'Actual Release',
      flex: 1,
      minWidth: 80,
      hide: episodeList,
    },
    {
      field: 'incarcerationInstitution',
      headerName: 'Incarceration Institution',
      minWidth: 100,
      renderCell: renderCellExpand,
      flex: 1,
      hide: episodeList,
    },
    {
      field: 'referralSource',
      headerName: 'Referral Source',
      minWidth: 100,
      renderCell: renderCellExpand,
      flex: 1,
    },
    {
      field: 'cCCMS',
      headerName: 'CCC Ms',
      type: 'boolean',
      flex: 1,
    },
    {
      field: 'lastCountyofResidence',
      headerName: 'Last County of Residence',
      minWidth: 120,
      flex: 1,
      hide: episodeList,
    },
    {
      field: 'paroleCounty',
      headerName: 'Parole County',
      renderCell: renderCellExpand,
      minWidth: 90,
      flex: 1,
    },
    {
      field: 'paroleOfficer',
      headerName: 'Parole Officer',
      renderCell: renderCellExpand,
      minWidth: 90,
      flex: 1,
      hide: !episodeList,
    },
    {
      field: 'paroleAgent',
      headerName: 'Parole Agent',
      minWidth: 90,
      renderCell: renderCellExpand,
      flex: 1,
      hide: episodeList,
    },
    {
      field: 'tIR',
      headerName: 'TIR',
      type: 'boolean',
      flex: 1,
      hide: episodeList,
    },
    {
      field: 'area',
      headerName: 'Area',
      renderCell: renderCellExpand,
      minWidth: 100,
      flex: 1,
      hide: episodeList,
    },
    {
      field: 'episodeDischargeDate',
      headerName: 'Episode Discharge Date',
      editable: true,
      type: 'date',
      minWidth: 100,
      flex: 1,
    },
    {
      field: 'episodeDischargeReason',
      headerName: 'Episode Discharge Reason',
      renderCell: renderCellExpand,
      minWidth: 90,
      flex: 1,
    },
    {
      field: 'participantId',
      headerName: 'Prt Id',
      flex: 1,
      minWidth: 90,
      hide: !episodeList,
    },
    {
      field: 'inactivity',
      headerName: 'Inactive',
      type: 'boolean',
      flex: 1,
    },
  ];

  const disableNewEpisode = episodeData.data.filter(
    (item) => item.inactivity === false
  );

  return (
    <>
      {!episodeList && (
        <Grid container style={{ padding: '10px 0px' }}>
          {/**
          <Grid item xs={6}>
            <Tooltip
              title={
                buttonDisabled
                  ? 'To enable this button please click on particular row of episode id'
                  : ''
              }
              placement='right'
              arrow
            >
              <span>
                <Button
                  disabled={buttonDisabled}
                  variant='contained'
                  onClick={handleClick}
                >
                  Episode Detail
                </Button>
              </span>
            </Tooltip>
          </Grid>
          **/}
          <LeftGrid item xs={12}>
            <Tooltip
              title={
                disableNewEpisode.length > 0
                  ? 'To enable this button inactive all the episodes'
                  : ''
              }
              placement="left"
              arrow
            >
              <span>
                <Button
                  disabled={disableNewEpisode.length > 0 ? true : false}
                  variant="contained"
                  onClick={() => newEpisodeDialod()}
                >
                  New Episode
                </Button>
              </span>
            </Tooltip>
          </LeftGrid>
        </Grid>
      )}
      <div style={{ height: 670, width: '100%' }}>
        <div style={{ display: 'flex', height: '100%' }}>
          <div style={{ flexGrow: 1 }}>
            <DataGrid
              disableColumnFilter
              //getRowHeight={() => 'auto'}
              columns={columnsData}
              rows={episodeList ? episodeListData.data : episodeData.data}
              pageSize={
                episodeList ? episodeListData.pageSize : episodeData.pageSize
              }
              page={episodeList ? episodeListData.page - 1 : episodeData.page - 1}
              rowCount={episodeList ? episodeListData.total : episodeData.total}
              paginationMode="server"
              sortingMode="server"
              onPageSizeChange={
                episodeList
                  ? (newPageSize) =>
                      setEpisodeListData((old) => ({
                        ...old,
                        pageSize: newPageSize,
                      }))
                  : (newPageSize) =>
                      setEpisodeData((old) => ({ ...old, pageSize: newPageSize }))
              }
              onPageChange={
                episodeList
                  ? (newPage) => {
                      setEpisodeListData((old) => ({ ...old, page: newPage + 1 }));
                    }
                  : (newPage) => {
                      setEpisodeData((old) => ({ ...old, page: newPage + 1 }));
                    }
              }
              onSortModelChange={handleSortModelChange}
              rowsPerPageOptions={paginationSize}
              pagination
              components={{ Toolbar: QuickSearchToolbar }}
              experimentalFeatures={{ newEditingApi: true }}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
              }
              onRowClick={(param) => setEpisodeComment(param.row.episodeComment)}
              loading={
                episodeList ? episodeListData.isLoading : episodeData.isLoading
              }
            />
          </div>
        </div>    
      </div>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box mt={2} style={{ display: 'flex', alignItems: 'center' }}>
            <TextField
              sx={{ width: '100%' }}
              label="Episode Comment"
              multiline
              disabled
              rows={4}
              defaultValue={episodeComment}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
        </Grid>
      </Grid>

      <EpisodeDialog
        open={open}
        setOpen={setOpen}
        fetchData={fetchData}
        authToken={user?.signInUserSession.accessToken.jwtToken}
        partcipantId={episodeParticipantDetail?.id}
        disableNewEpisode={disableNewEpisode}
        openBackdrop={openBackdrop}
        user={user}
      />
    </>
  );
};
export default Episode;
